//=require tools/svg-template.js

var CollapsablePanel = (function ($) {
    var CollapsablePanel, svgIcon;

    CollapsablePanel = function (options) {
        var container, thisCollapsablePanel;

        thisCollapsablePanel = this;
        container = this.container = $(options.container);

        if (options.headerPanel) {
            this.headerPanel = $(options.headerPanel);
        } else {
            this.headerPanel = this.container.children('.collapsable-panel-header');
        }

        this.openClass = options.openClass || 'collapsable-panel-open';

        // inject svg icons
        this.headerPanel.append(svgIcon('chevron-up'));
        this.headerPanel.append(svgIcon('chevron-down'));

        this.headerPanel.click(function (e) {
            e.preventDefault();
            thisCollapsablePanel.toggle();
        });
    };

    CollapsablePanel.prototype.toggle = function (setOpen) {
        if (setOpen === undefined) {
            setOpen = !this.container.hasClass(this.openClass);
        }
        if (setOpen) {
            this.open();
        } else {
            this.close();
        }
    };

    CollapsablePanel.prototype.open = function () {
        this.container.addClass(this.openClass);
    }

    CollapsablePanel.prototype.close = function () {
        this.container.removeClass(this.openClass);
    }

    svgIcon = function (name) {
        return svgTemplate(name);
    };

    // "export" it
    return CollapsablePanel
})($);
